import { initials } from '@employer-on-record/shared';
import { avatarPalette, cn } from '@/lib/utils';

interface Props {
	name: string;
	size?: number;
	palette?: number;
	className?: string;
}

export function Avatar({ name, size = 32, palette, className }: Props) {
	const idx = palette ?? avatarPalette(name);
	return (
		<div
			className={cn(`av av-${idx} flex items-center justify-center rounded-full font-semibold shrink-0`, className)}
			style={{ width: size, height: size, fontSize: Math.round(size * 0.36) }}
		>
			{initials(name)}
		</div>
	);
}
